import React, { useRef, useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import LayoutOne from '../../layouts/LayoutOne';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
const Careers = () => {
  const jobListings = [
    {
      id: 1,
      title: "Sales Manager",
      type: "Full Time",
      experience: "3 - 4 Years Experience",
      salary: "₹50,000 - ₹60,000",
      description: "We Are Seeking A Highly Motivated And Experienced Sales Manager To Lead The Operations Of Our Mobile Store. This Role Offers An Exciting Opportunity To Manage A Team Of Sales Professionals, Drive Performance, And Deliver An Exceptional Customer Experience. As The Sales Manager, You Will Play A Pivotal Role In Ensuring The Store's Success By Implementing Effective Sales Strategies And Fostering A Culture Of Excellence.\n\nIn This Position, You Will Oversee Daily Sales Operations, Manage Inventory, And Ensure That Customers Receive Expert Guidance On Our Range Of Mobile Products And Accessories. You Will Be Responsible For Setting Sales Targets, Analyzing Performance Metrics, And Creating Actionable Plans To Exceed Goals. By Providing Mentorship And Support To Your Team, You Will Empower Them To Excel And Maintain A High Standard Of Service."
    },
    {
      id: 2,
      title: "Marketing Admin",
      type: "Full Time",
      experience: "3 - 4 Years Experience",
      salary: "₹50,000 - ₹60,000",
      description: "We Are Seeking A Highly Motivated And Experienced Sales Manager To Lead The Operations Of Our Mobile Store. This Role Offers An Exciting Opportunity To Manage A Team Of Sales Professionals, Drive Performance, And Deliver An Exceptional Customer Experience. As The Sales Manager, You Will Play A Pivotal Role In Ensuring The Store's Success By Implementing Effective Sales Strategies And Fostering A Culture Of Excellence.\n\nIn This Position, You Will Oversee Daily Sales Operations, Manage Inventory, And Ensure That Customers Receive Expert Guidance On Our Range Of Mobile Products And Accessories. You Will Be Responsible For Setting Sales Targets, Analyzing Performance Metrics, And Creating Actionable Plans To Exceed Goals. By Providing Mentorship And Support To Your Team, You Will Empower Them To Excel And Maintain A High Standard Of Service."
    },
    {
      id: 3,
      title: "Sales Person",
      type: "Full Time",
      experience: "3 - 4 Years Experience",
      salary: "₹50,000 - ₹60,000",
      description: "We Are Seeking A Highly Motivated And Experienced Sales Manager To Lead The Operations Of Our Mobile Store. This Role Offers An Exciting Opportunity To Manage A Team Of Sales Professionals, Drive Performance, And Deliver An Exceptional Customer Experience. As The Sales Manager, You Will Play A Pivotal Role In Ensuring The Store's Success By Implementing Effective Sales Strategies And Fostering A Culture Of Excellence.\n\nIn This Position, You Will Oversee Daily Sales Operations, Manage Inventory, And Ensure That Customers Receive Expert Guidance On Our Range Of Mobile Products And Accessories. You Will Be Responsible For Setting Sales Targets, Analyzing Performance Metrics, And Creating Actionable Plans To Exceed Goals. By Providing Mentorship And Support To Your Team, You Will Empower Them To Excel And Maintain A High Standard Of Service."
    }
  ];
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    file: null
  });

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleFileUpload = (e) => {
    setFormData({
      ...formData,
      file: e.target.files[0]
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
    // Close modal after submission
    handleCloseModal();
  };
  return (
    <LayoutOne>

      <div
        className="position-relative text-white"
        style={{
          backgroundImage: 'url("/assets/img/svg/joint_banner_section.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '350px'
        }}
      >
        {/* Overlay */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}
        ></div>

        {/* Content */}
        <div className="container h-100 position-relative d-flex flex-column justify-content-center">
          <div className="ps-3">
            <h1 className="display-4 fw-bold text-white mb-2">Careers</h1>
            <p className="fs-5 text-white mb-3">
              Be a part of our journey to deliver excellence in mobile solutions.
            </p>
            <button className="btn text-white fw-semibold" style={{ backgroundColor: '#1a4ba1', fontSize: '14px' }}>
              ABOUT US
            </button>
          </div>
        </div>
      </div>

      {/* Talent Pool Section */}
      <section style={{ padding: '60px 0' }}>
        <div className="container">
          <h2 style={{
            fontSize: '26px',
            fontWeight: '600',
            marginBottom: '20px',
            color: '#333'
          }}>
            Join Our Talent Pool For Future Opportunities
          </h2>
          <p style={{
            fontSize: '16px',
            lineHeight: '1.6',
            marginBottom: '20px',
            color: '#666'
          }}>
            Although We Currently Don't Have Open Positions, We're Always On The Lookout For
            Talented Individuals To Join Our Team In The Future. Submit Your Details Today, And
            We'll Keep You In Mind For Upcoming Roles That Match Your Skills And Aspirations.
          </p>

          {/* Button to open modal */}
          <Button
            style={{
              backgroundColor: '#1a4ba1',
              color: 'white',
              border: 'none',
              padding: '8px 20px',
              borderRadius: '4px',
              fontWeight: '600',
              fontSize: '14px'
            }}
            onClick={handleOpenModal}
          >
            SEND CV
          </Button>

          {/* Bootstrap Modal */}
          <Modal
            show={showModal}
            onHide={handleCloseModal}
            centered
          >
            <Modal.Header>
              <div className="w-100 text-center">
                <h6 className="modal-title">Enquiry For</h6>
                <h5>Sales Manager</h5>
              </div>
              <Button variant="close" onClick={handleCloseModal} aria-label="Close" />
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit} style={{ padding: "0px 100px 0px 100px" }}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Your Name..."
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Your Email..."
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    type="tel"
                    name="phone"
                    placeholder="Your Number..."
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <div
                    className="form-control text-center"
                    style={{ cursor: 'pointer' }}
                    onClick={() => document.getElementById('file-upload').click()}
                  >
                    <span>📎 Click to Upload or drag CV & Cover letter here.</span>
                    <Form.Control
                      type="file"
                      id="file-upload"
                      className="form-control-file mt-2"
                      onChange={handleFileUpload}
                      style={{ display: 'none' }}
                    />
                  </div>
                  {formData.file && (
                    <div className="mt-2 text-center text-success">
                      File selected: {formData.file.name}
                    </div>
                  )}
                </Form.Group>

                <Button
                  type="submit"
                  variant="primary"
                  className="w-100"
                  style={{
                    backgroundColor: '#1a4ba1',
                    border: 'none'
                  }}
                >
                  Submit Enquiry
                </Button>
              </Form>
            </Modal.Body>
          </Modal>
        </div>
      </section>

      <div className="container py-4 overflow-hidden">
        {jobListings.map((job) => (
          <div
            key={job.id}
            className="row bg-white rounded shadow-sm mb-4 p-4 border-bottom border-light align-items-start gx-4"
          >
            {/* Left Column */}
            <div className="col-md-4 d-flex flex-column justify-content-between mb-3 mb-md-0">
              <div>
                <span className="text-muted small d-block mb-1">{job.type}</span>
                <h5 className="fw-semibold text-dark mb-2">{job.title}</h5>
                <span className="text-muted small d-block mb-1">{job.experience}</span>
                <span className="fw-medium text-dark">{job.salary}</span>
              </div>

              <button
                style={{ backgroundColor: "#1a4ba1" }}
                className="btn  btn-primary rounded-pill mt-3 d-inline-flex align-items-center gap-2 px-4 py-2 fw-semibold w-50 w-md-50"
              >
                ENQUIRY
                <span
                  className="bg-success rounded-circle d-inline-block"
                  style={{ width: '10px', height: '10px' }}
                ></span>
              </button>
            </div>

            {/* Right Column */}
            <div className="col-md-8">
              <p
                className="text-secondary mb-0"
                style={{ lineHeight: '1.7', fontSize: '15px', wordBreak: 'break-word', textAlign: "justify" }}
              >
                {job.description}
              </p>
            </div>
          </div>
        ))}
      </div>



      {/* Toolbar - Just for visual representation */}

    </LayoutOne>
  );
};

export default Careers;